import { APTerm } from '../../../global/builders/ap_term_builder';
import { APTermServant } from '../../../global/servants/ap_term_servant';

export class TermBoxCountdownTimerController {
  private term: APTerm;
  private startTime?: moment.Moment;
  private timeString: string;
  private timer: ng.IIntervalService;

  constructor(private $interval: any) {}

  changeTime(time: moment.Moment) {
    const now = moment();
    const duration = moment.duration(time.diff(now));
    this.timeString = `
        <span class="text-bold number">${duration.days()}</span>days &nbsp;|&nbsp;
        <span class="text-bold">${duration.hours()}</span>hours,&nbsp;
        <span class="text-bold">${duration.minutes()}</span>minutes,&nbsp;
        <span class="text-bold">${duration.seconds()}</span>seconds
        `;
  }

  startTimer(startTime: moment.Moment) {
    const UPDATE_INTERVAL = 1000;
    this.timer = this.$interval(() => this.changeTime(startTime), UPDATE_INTERVAL);
  }

  $onChanges() {
    this.startTime = this.term.priority_registration_start_dt;
    if (APTermServant.hasPriorityReg(this.term) && this.startTime) {
      this.startTimer(this.startTime);
    }
  }
}

class TermBoxCountdownTimer implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      term: '<'
    };
    this.controller = TermBoxCountdownTimerController;
    this.templateUrl =
      'capability-ng-academic-planner/src/plan/components/term_box_countdown_timer/term_box_countdown_timer.html';
  }
}
angular.module('capability-ng-academic-planner').component('termBoxCountdownTimer', new TermBoxCountdownTimer());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box_countdown_timer/term_box_countdown_timer.ts